/* Autogenerated file. Do not edit manually. */
/* tslint:disable */
/* eslint-disable */
import { Contract, ContractFactory, Interface, } from "ethers";
const _abi = [
    {
        inputs: [],
        stateMutability: "nonpayable",
        type: "constructor",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "sender",
                type: "address",
            },
            {
                internalType: "uint256",
                name: "tokenId",
                type: "uint256",
            },
            {
                internalType: "address",
                name: "owner",
                type: "address",
            },
        ],
        name: "ERC721IncorrectOwner",
        type: "error",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "operator",
                type: "address",
            },
            {
                internalType: "uint256",
                name: "tokenId",
                type: "uint256",
            },
        ],
        name: "ERC721InsufficientApproval",
        type: "error",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "approver",
                type: "address",
            },
        ],
        name: "ERC721InvalidApprover",
        type: "error",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "operator",
                type: "address",
            },
        ],
        name: "ERC721InvalidOperator",
        type: "error",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "owner",
                type: "address",
            },
        ],
        name: "ERC721InvalidOwner",
        type: "error",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "receiver",
                type: "address",
            },
        ],
        name: "ERC721InvalidReceiver",
        type: "error",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "sender",
                type: "address",
            },
        ],
        name: "ERC721InvalidSender",
        type: "error",
    },
    {
        inputs: [
            {
                internalType: "uint256",
                name: "tokenId",
                type: "uint256",
            },
        ],
        name: "ERC721NonexistentToken",
        type: "error",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "owner",
                type: "address",
            },
        ],
        name: "OwnableInvalidOwner",
        type: "error",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "account",
                type: "address",
            },
        ],
        name: "OwnableUnauthorizedAccount",
        type: "error",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: true,
                internalType: "address",
                name: "owner",
                type: "address",
            },
            {
                indexed: true,
                internalType: "address",
                name: "approved",
                type: "address",
            },
            {
                indexed: true,
                internalType: "uint256",
                name: "tokenId",
                type: "uint256",
            },
        ],
        name: "Approval",
        type: "event",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: true,
                internalType: "address",
                name: "owner",
                type: "address",
            },
            {
                indexed: true,
                internalType: "address",
                name: "operator",
                type: "address",
            },
            {
                indexed: false,
                internalType: "bool",
                name: "approved",
                type: "bool",
            },
        ],
        name: "ApprovalForAll",
        type: "event",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: true,
                internalType: "address",
                name: "previousOwner",
                type: "address",
            },
            {
                indexed: true,
                internalType: "address",
                name: "newOwner",
                type: "address",
            },
        ],
        name: "OwnershipTransferred",
        type: "event",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: true,
                internalType: "address",
                name: "from",
                type: "address",
            },
            {
                indexed: true,
                internalType: "address",
                name: "to",
                type: "address",
            },
            {
                indexed: true,
                internalType: "uint256",
                name: "tokenId",
                type: "uint256",
            },
        ],
        name: "Transfer",
        type: "event",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "to",
                type: "address",
            },
            {
                internalType: "uint256",
                name: "tokenId",
                type: "uint256",
            },
        ],
        name: "approve",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "owner",
                type: "address",
            },
        ],
        name: "balanceOf",
        outputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "uint256",
                name: "tokenId",
                type: "uint256",
            },
        ],
        name: "getApproved",
        outputs: [
            {
                internalType: "address",
                name: "",
                type: "address",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "owner",
                type: "address",
            },
            {
                internalType: "address",
                name: "operator",
                type: "address",
            },
        ],
        name: "isApprovedForAll",
        outputs: [
            {
                internalType: "bool",
                name: "",
                type: "bool",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "to",
                type: "address",
            },
        ],
        name: "mint",
        outputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [],
        name: "name",
        outputs: [
            {
                internalType: "string",
                name: "",
                type: "string",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "owner",
        outputs: [
            {
                internalType: "address",
                name: "",
                type: "address",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "uint256",
                name: "tokenId",
                type: "uint256",
            },
        ],
        name: "ownerOf",
        outputs: [
            {
                internalType: "address",
                name: "",
                type: "address",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "renounceOwnership",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "from",
                type: "address",
            },
            {
                internalType: "address",
                name: "to",
                type: "address",
            },
            {
                internalType: "uint256",
                name: "tokenId",
                type: "uint256",
            },
        ],
        name: "safeTransferFrom",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "from",
                type: "address",
            },
            {
                internalType: "address",
                name: "to",
                type: "address",
            },
            {
                internalType: "uint256",
                name: "tokenId",
                type: "uint256",
            },
            {
                internalType: "bytes",
                name: "data",
                type: "bytes",
            },
        ],
        name: "safeTransferFrom",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "operator",
                type: "address",
            },
            {
                internalType: "bool",
                name: "approved",
                type: "bool",
            },
        ],
        name: "setApprovalForAll",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "bytes4",
                name: "interfaceId",
                type: "bytes4",
            },
        ],
        name: "supportsInterface",
        outputs: [
            {
                internalType: "bool",
                name: "",
                type: "bool",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "symbol",
        outputs: [
            {
                internalType: "string",
                name: "",
                type: "string",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "uint256",
                name: "tokenId",
                type: "uint256",
            },
        ],
        name: "tokenURI",
        outputs: [
            {
                internalType: "string",
                name: "",
                type: "string",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "from",
                type: "address",
            },
            {
                internalType: "address",
                name: "to",
                type: "address",
            },
            {
                internalType: "uint256",
                name: "tokenId",
                type: "uint256",
            },
        ],
        name: "transferFrom",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "newOwner",
                type: "address",
            },
        ],
        name: "transferOwnership",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
];
const _bytecode = "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";
const isSuperArgs = (xs) => xs.length > 1;
export class ExampleERC721Token__factory extends ContractFactory {
    constructor(...args) {
        if (isSuperArgs(args)) {
            super(...args);
        }
        else {
            super(_abi, _bytecode, args[0]);
        }
    }
    getDeployTransaction(overrides) {
        return super.getDeployTransaction(overrides || {});
    }
    deploy(overrides) {
        return super.deploy(overrides || {});
    }
    connect(runner) {
        return super.connect(runner);
    }
    static createInterface() {
        return new Interface(_abi);
    }
    static connect(address, runner) {
        return new Contract(address, _abi, runner);
    }
}
ExampleERC721Token__factory.bytecode = _bytecode;
ExampleERC721Token__factory.abi = _abi;
//# sourceMappingURL=ExampleERC721Token__factory.js.map